import {
    FieldInCard,
} from 'app/types/form.types'
import {
    OrderModificationType,
    ProductType,
} from 'app/enums/label.enums'

import {
    ModificationRequiredContainersType,
} from '../../longTermLease.types'

const getFields = ({
    allowedProductTypes,
    getAllowedValues,
}: {
    allowedProductTypes: ProductType[],
    getAllowedValues: (enumType: Record<string, string>) => Record < string, string >,
}): FieldInCard<keyof ModificationRequiredContainersType>[] => {
    return [
        {
            id: 'column1',
            fields: [
                {
                    name: 'modificationReason',
                    componentName: 'EnumSelector',
                    allowedValues: getAllowedValues(OrderModificationType),
                    useDropdown: true,
                    required: true,
                    labelKey: 'OrderByNumberView.modificationReason',
                },
                {
                    name: 'modificationComment',
                    componentName: 'LongText',
                    multiline: true,
                    required: true,
                    labelKey: 'OrderByNumberView.modificationComment',
                },
            ],
        },
        {
            id: 'column2',
            fields: [
                {
                    name: 'requiredContainers',
                    componentName: 'RequiredContainerByProductTypeList',
                    allowedProductTypes,
                    required: true,
                    labelKey: 'OrderByNumberView.requiredContainers',
                },
                {
                    name: 'cargoComment',
                    componentName: 'LongText',
                    multiline: true,
                    labelKey: 'OrderByNumberView.requiredCargoComment',
                },
            ],
        },
    ]
}

export default getFields
